/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_TipsInputs */

const en_close_tips = /** @type {(inputs: Close_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Tips`)
};

const fr_close_tips = /** @type {(inputs: Close_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer les nouveautés`)
};

const de_close_tips = /** @type {(inputs: Close_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipps schließen`)
};

const it_close_tips = /** @type {(inputs: Close_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi Suggerimenti`)
};

const ru_close_tips = /** @type {(inputs: Close_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Советы по закрытию`)
};

const es_close_tips = /** @type {(inputs: Close_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consejos para cerrar`)
};

const zh_cn2_close_tips = /** @type {(inputs: Close_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`温馨提示`)
};

const ja_close_tips = /** @type {(inputs: Close_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヒントを閉じる`)
};

const hi_close_tips = /** @type {(inputs: Close_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद करने के सुझाव`)
};

const pt_pt2_close_tips = /** @type {(inputs: Close_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dicas de fechamento`)
};

/**
* | output |
* | --- |
* | "Close Tips" |
*
* @param {Close_TipsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_tips = /** @type {((inputs?: Close_TipsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_TipsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_close_tips(inputs)
	if (locale === "de") return de_close_tips(inputs)
	if (locale === "it") return it_close_tips(inputs)
	if (locale === "ru") return ru_close_tips(inputs)
	if (locale === "es") return es_close_tips(inputs)
	if (locale === "zh-CN") return zh_cn2_close_tips(inputs)
	if (locale === "ja") return ja_close_tips(inputs)
	if (locale === "hi") return hi_close_tips(inputs)
	if (locale === "pt-PT") return pt_pt2_close_tips(inputs)
	return en_close_tips(inputs)
});